import styled from 'styled-components';
import { is } from 'ramda';
import { FormattedNumber } from 'react-intl';

export const NumberCellWrapper = styled.div`
  font-family: 'Roboto Mono', monospace;
`;

export const NumberCell = (value: string | number) => {
  const numericValue = is(String, value) ? (value as string).replace(',', '.') : value;

  return (
    <NumberCellWrapper>
      {isNaN(Number(numericValue)) ? ' - ' : <FormattedNumber value={Number(numericValue)} />}
    </NumberCellWrapper>
  );
};
